<template>
  <div class="teachingActivity">
    <div :class="['activity_box',{'disscussion-activity_box': query.type === 5}]">
      <div :class="['header', { 'disscussion-header': query.type === 5 }]">
        <div class="header_left">
          <span class="zhangjie"> {{ query.zhangName }} / {{query.jieName }}</span>
          <span class="name">{{ query.name }}</span>
          <div class="countDown">
            <span v-if="query.status==0">已结束</span>
            <span v-else>
              <span style="color:#FD8C41">{{countdown}}</span>
              <span v-if="this.query.duration===0">无限制</span>
            </span>
          </div>
        </div>
        <el-button class="back_button" @click="goBack">返回</el-button>
      </div>
      <div class="content">
        <SignInDetails v-if="query.type==1"></SignInDetails>
        <VotingDetails v-if="query.type==2"></VotingDetails>
        <ChooseSomeoneDetial v-if="query.type==3" :hideButton="hideButton"></ChooseSomeoneDetial>
        <QuickAnswerDetails v-if="query.type==4" ref="QuickAnswerDetailsRef"></QuickAnswerDetails>
        <ThematicDiscussionDetial v-if="query.type==5" :status="query.status"></ThematicDiscussionDetial>
        <InClassDiscussionDetial v-if="query.type==6"></InClassDiscussionDetial>
      </div>
    </div>
  </div>
</template>

<script>
import WsConfig from "@/utils/wsConfig";
import { sendWsData } from "@/utils/utils";
import VotingDetails from "./component/VotingDetails.vue";
import ThematicDiscussionDetial from "./component/ThematicDiscussionDetial.vue";
import ChooseSomeoneDetial from "./component/ChooseSomeoneDetial.vue";
import InClassDiscussionDetial from "./component/InClassDiscussionDetial.vue";
import QuickAnswerDetails from "./component/QuickAnswerDetails.vue";
import SignInDetails from "./component/SignInDetails.vue";
export default {
  components: {
    VotingDetails,
    ThematicDiscussionDetial,
    ChooseSomeoneDetial,
    InClassDiscussionDetial,
    QuickAnswerDetails,
    SignInDetails,
  },
  data() {
    return {
      countdown: "",
      query: {
        type: 3,
      },
      hideButton: true,
      wsIns: null,
      wsTimer: null,
    };
  },
  created() {
    this.websocketInit();
    this.query = JSON.parse(localStorage.getItem("query"));
    this.query.zhangName = this.query.zhangName
      ? this.query.zhangName
      : localStorage.getItem("zhangName");
    this.query.jieName = this.query.jieName
      ? this.query.jieName
      : localStorage.getItem("jieName");

    if (this.query.duration != 0 ) {
      this.getCountdown(this.query.create_time, this.query.duration);
    }
  },
  methods: {
    websocketInit() {
      this.wsIns = new WebSocket(WsConfig.url);
      console.log("WsConfig.url", WsConfig.url);

      this.wsIns.onopen = () => {
        this.wsIns.send(sendWsData("bind"));
        if (this.wsTimer) clearInterval(this.wsTimer);
        this.wsTimer = setInterval(() => {
          const sendMsg = sendWsData("ping");
          this.wsIns.send(sendMsg);
        }, 50000);
      };
      this.wsIns.onmessage = (evt) => {
        const data = JSON.parse(evt.data);

        switch (data.type) {
          // 连接成功
          case "connect":
            this.bindClient(data.data.client_id);
            break;
          case "new_act":
           // console.log("收到新活动通知：", data);
            break;
          case "stop_act":
            //console.log("活动停止：", data);
            break;
          case "del_act":
            //console.log("活动删除：", data);
            break;
          case "join_group":
           // console.log("加入班级", data);
            break;
          case "reset_select_person":
            //console.log("重置选人", data);
            break;
          case "rand_select_person":
            //console.log("随机选人", data);
            break;
          case "answer_record_info":
          console.log("学生抢答成功", data);
          this.$refs.QuickAnswerDetailsRef.getQuickAnswerDetial()
            break;
          default:
          // console.log("收到未知类型消息：", data);
        }
      };
      //断开之后重连
      this.wsIns.onclose = () => {
        console.log("已断开连接，尝试重新连接");
        this.websocketInit();
      };
    },
    // 绑定客户端
    bindClient(client_id) {
      this.$shttp.axiosPost(
        this.$api.jdWsBind,
        { client_id: client_id, class_id: localStorage.getItem("class_id") },
        (res) => {
          if (res.code == 200) {
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getCountdown(create_time, duration1) {
      const startTime = new Date(create_time);
      // 定义倒计时时长（5 分钟，单位：毫秒）
      //duration1 = duration1 == 4 ? duration1 + 1 : duration1;
      const duration = duration1 * 60 * 1000;
      // 计算结束时间
      const endTime = new Date(startTime.getTime() + duration);
      // 初始调用一次更新函数
      this.updateCountdown(endTime);
      // 每秒更新一次倒计时
      this.intervalId = setInterval(() => {
        this.updateCountdown(endTime);
      }, 1000);
    },
    // 更新倒计时的函数
    updateCountdown(endTime) {
      const now = new Date();
      let remainingTime = endTime - now;

      if (remainingTime > 0) {
          let hours = 0;
          const day = Math.floor(remainingTime / (3600 * 1000 * 24))
          if (day > 0) {
              remainingTime = remainingTime % (3600 * 1000 * 24)
          }
          hours = Math.floor(remainingTime / (3600 * 1000))

          if (hours > 0) {
              remainingTime = remainingTime % (3600 * 1000)
          }


        const minutes = Math.floor(
          (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

        this.countdown = `${minutes.toString().padStart(2, "0")}分${seconds
          .toString()
          .padStart(2, "0")}秒`;
          if (hours > 0) {
            this.countdown = `${hours}时` + this.countdown
          }
          if (day > 0) {
            this.countdown = `${day}天` + this.countdown
          }
          this.countdown = "剩余" + this.countdown;
      } else {
        this.countdown = "已结束";
        this.hideButton = false;
        clearInterval(this.intervalId);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    Hidebutton() {},
    beforeDestroy() {
      // 组件销毁前清除定时器
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.teachingActivity {
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
  padding: 20px;
  box-sizing: border-box;
  .activity_box {
    width: 100%;
    height: 100%;
    background: #fff;
  }
  .disscussion-activity_box {
    background: #f2f2f2;
  }

  .back_button {
    width: 88px;
    height: 36px;
    background: #006eff;
    border-radius: 4px 4px 4px 4px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.header {
  height: 60px;
  padding: 0 40px;
  box-sizing: border-box;
  border-bottom: 1px solid #e4e4e4;

  &.disscussion-header {
    background-color: #ffffff;
    margin: 0px 20px 0 20px;
    border-radius: 4px;
    border: none;
  }

  .header_left {
    height: 100%;
    display: flex;
    align-items: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    line-height: 19px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .zhangjie {
    }
    .name {
      margin: 0 30px;
    }
    .countdown {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #fd8c41;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content {
  width: 100%;
  height: calc(100vh - 215px);
  overflow-y: auto;
}
/* 设置滚动条整体 */
::-webkit-scrollbar {
  width: 3px; /* 滚动条宽度 */
  height: 6px; /* 水平滚动条高度 */
}

/* 设置滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 轨道背景色 */
}

/* 设置滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #d3d3d3; /* 滑块背景色 */
  border-radius: 10px; /* 滑块圆角 */
}

/* 设置滚动条滑块悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #a3a2a2; /* 滑块悬停背景色 */
}
</style>
